import { createReducer } from '@reduxjs/toolkit';

import postRegistration from '../../thunks/auth/registration';

const initialState = {
  loading: false,
  error: null,
  registered: false
};

const registrationReducer = createReducer(initialState, {
  [postRegistration.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
    registered: false
  }),

  [postRegistration.fulfilled]: (state, { payload: user }) => ({
    ...state,
    loading: false,
    registered: !!user,
  }),

  [postRegistration.rejected]: (state, { payload: error }) => ({
    ...state,
    loading: false,
    error,
    registered: false
  })
});

export default registrationReducer;
